var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-container",on:{"click":_vm.openLink}},[_c('img',{staticClass:"icon",attrs:{"src":require("../../assets/sidebar/info.svg"),"alt":"","color":"primary"}})])}
var staticRenderFns = []

export { render, staticRenderFns }